module.exports = __webpack_public_path__ + "img/radio-button-on.ebfecfd3.svg";